export {
    SuiPaginationModule,
    SuiPagination
} from "./index";
